// src/components/VisitorContactWidget/utils/contactWidgetStorage.js

const CONVERSATION_ID_KEY =
  "monappliclub_visitor_conversation_id";

const INVITATION_DISMISSED_KEY =
  "monappliclub_contact_invitation_dismissed";

const VISITOR_CONTACT_KEY =
  "monappliclub_visitor_contact";

export function getStoredConversationId() {
  const value = sessionStorage.getItem(
    CONVERSATION_ID_KEY,
  );

  if (!value) return null;

  const conversationId = Number(value);

  return Number.isFinite(conversationId)
    ? conversationId
    : null;
}

export function saveConversationId(conversationId) {
  if (!conversationId) return;

  sessionStorage.setItem(
    CONVERSATION_ID_KEY,
    String(conversationId),
  );
}

export function removeConversationId() {
  sessionStorage.removeItem(CONVERSATION_ID_KEY);
}

export function hasDismissedInvitation() {
  return (
    sessionStorage.getItem(
      INVITATION_DISMISSED_KEY,
    ) === "true"
  );
}

export function dismissInvitationForSession() {
  sessionStorage.setItem(
    INVITATION_DISMISSED_KEY,
    "true",
  );
}

export function getStoredVisitorContact() {
  try {
    const value = sessionStorage.getItem(
      VISITOR_CONTACT_KEY,
    );

    if (!value) return null;

    return JSON.parse(value);
  } catch {
    return null;
  }
}

export function saveVisitorContact(contact) {
  if (!contact) return;

  sessionStorage.setItem(
    VISITOR_CONTACT_KEY,
    JSON.stringify({
      name: contact.name || "",
      email: contact.email || "",
      phone: contact.phone || "",
      organization_name:
        contact.organization_name || "",
    }),
  );
}